import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import  { fncManifestDetails } from '../Utility/ApiCall.js';
import { flightManifestDetails } from '../ReduxState';

function ManifestDetail({handleSideMenu}) {
    const history = useHistory();
    const dispatch = useDispatch();
    const manifest = useSelector(state => state.sidemenu.manifestDetails);
    const SearchedRecordData = useSelector(state => state.search.SearchedRecordData);
    const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
    const redirectTo = useSelector(state => state.sidemenu.redirectionPage);
    const Location = useSelector(state => state.login.Location);
    const [passengerSummary, setPassengerSummary] = useState({
        checkedInMale: 0,
        checkedInFemale: 0,
        checkedInChild: 0,
        checkedInInfant: 0,
        nonCheckedInMale: 0,
        nonCheckedInFemale: 0,
        nonCheckedInChild: 0,
        nonCheckedInInfant: 0,
        boardedMale: 0,
        boardedFemale: 0,
        boardedChild: 0,
        boardedInfant: 0,
        noShowMale: 0,
        noShowFemale: 0,
        noShowChild: 0,
        noShowInfant: 0
    });
    const [flightDate, setFlightDate] = useState(new Date());
    const ReduxDestinationDropdown = useSelector(state => state.selectedpassenger.DestinationDropdown);
    const ReduxOriginDropdown = useSelector(state => state.selectedpassenger.OriginDropdown);
    const [origin, setOrigin] =  useState(Location);
    const [flightnum, setFlightNum] = useState('');
    const [destination, setDestination] = useState('');
    const [dateError, setErrorDate] = useState('');
    const [st_ErrorOrigin, setErrorOrigin] = useState('');
    const [st_ErrorFlightNum, setErrorFlightNum] = useState('');
    const [st_ErrorDestination, setErrorDestination] = useState('');
    const notify = (e) =>
    toast.error(e, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
    });
    const goBack = () => {
        history.push(redirectTo);
    }

    const goBackFromList = () => {
        if (!(SearchedFlightDetails && SearchedFlightDetails.recordLocator) && manifest !== null) {
            dispatch(flightManifestDetails(
                {
                        type: "",
                        manifestDetails: null
                }
        ));
        }
        history.push(redirectTo);
    }

    const handleDateChange = (e) => {
        console.log(e);
        setErrorDate('');
        setFlightDate(e);
    }

    const handleDateSelect = (e) => {
            setErrorDate('');
            setFlightDate(e);
    }

    useEffect(() => {
        let selectedSegment = [];
        let apiRequest = {};
        if (SearchedRecordData.length && SearchedFlightDetails && SearchedFlightDetails.recordLocator && manifest === null) {
            let shouldSkip = false;
            SearchedRecordData.forEach(items => {
                    items.passengerData.forEach(p => {
                    if (shouldSkip) {
                        return;
                    }
                    selectedSegment = p.segments.filter(s => s.IsSelected);
                    if (selectedSegment.length) {
                        shouldSkip = true;
                        return;
                    }
                    });
            });
            debugger
            if (selectedSegment.length) {
                apiRequest = {
                    LegKey: selectedSegment[0].legs[0].legKey
                //   Date: selectedSegment[0].departureTime,
                //   DepartureStation: selectedSegment[0].origin,
                //   ArrivalStation: selectedSegment[0].destination,
                //   FlightNo: selectedSegment[0].flightNumber,
                //   CarrierCode: selectedSegment[0].carrierCode
                }
                fncManifestDetails(apiRequest)
                .then((response) => {
  
                  if (response.status == "401" && response.data == "") {
                    console.log(response.statusText);
                  }else {
                    if (!response.data.isError) {
                            // console.log('response.data', response);
                            dispatch(flightManifestDetails(
                                    {
                                            type: "",
                                            manifestDetails: {
                                                    totalManifestCounts: response.data.totalManifestCounts,
                                                    passengerSummaries: response.data.passengerSummaries
                                            }
                                    }
                            ));
                    } else {
                            // notify(response.data.errorDetail.errorMessage);
                            console.log(response.data.errorDetail);
                    }
                }
                })
            }
        }

    }, [SearchedRecordData, manifest]);

    useEffect(() => {
        if (manifest && manifest.passengerSummaries.length) {
            const psum = {...passengerSummary};
            manifest.passengerSummaries.forEach(psummary => {
                if (psummary.status === 0) {
                    psum.nonCheckedInChild = psummary.totalChildCount;
                    psum.nonCheckedInFemale = psummary.totalFemaleCount;
                    psum.nonCheckedInInfant = psummary.totalInfantCount;
                    psum.nonCheckedInMale = psummary.totalMaleCount;
                } else if (psummary.status === 1) {
                    psum.checkedInChild = psummary.totalChildCount;
                    psum.checkedInFemale = psummary.totalFemaleCount;
                    psum.checkedInInfant = psummary.totalInfantCount;
                    psum.checkedInMale = psummary.totalMaleCount;
                } else if (psummary.status === 2) {
                    psum.boardedChild = psummary.totalChildCount;
                    psum.boardedFemale = psummary.totalFemaleCount;
                    psum.boardedInfant = psummary.totalInfantCount;
                    psum.boardedMale = psummary.totalMaleCount;
                } else if (psummary.status === 3) {
                    psum.noShowChild = psummary.totalChildCount;
                    psum.noShowFemale = psummary.totalFemaleCount;
                    psum.noShowInfant = psummary.totalInfantCount;
                    psum.noShowMale = psummary.totalMaleCount;
                }  
            });
            setPassengerSummary(psum);
        }
    }, [manifest, SearchedFlightDetails]);

    useEffect(() => {
        // function that checks for the Escape key
        debugger
        const handleKeyDown = (event) => {
          if (event.key === "Escape") {
            goBack(); // Close the popup
          }
        };
    
        // Add the event listener when the component mounts
        document.addEventListener("keydown", handleKeyDown);
    
        // Clean up the event listener when the component unmounts
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [redirectTo]);

    useEffect(() => {
              //  debugger
               document.addEventListener("keydown", function (event) {  
                 if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
                   handleSideMenu();
                 }
               })
             });

    const fncOriginChange = (e) => {
        let originID = e.target.value;
        if (originID.toUpperCase() == "Select a Origin".toUpperCase()) {
                originID = "";
        }
        setErrorOrigin("");
        setOrigin(originID);
    }

    const fncDestinationChange = (e) => {
                
        // console.log(e);
        let DestinationValue = e.target.value;
        // var DestinationID = e.target.id;
        if (DestinationValue.toUpperCase() == "Select a Destination".toUpperCase()) {
                DestinationValue = "";
        }
        setErrorDestination("");
        setDestination(DestinationValue);
    }

    const fncOnchange = (e) => {
        // var id = e.target.id;
        const value = e.target.value;
        if (value !== "") {
            if (/^[0-9]+$/.test(value)) {
                if (value.length <= 5) {
                    setFlightNum(value);
                    setErrorFlightNum("");
                    //fncTransitionEffect(value, id, fieldId);
                }
            }
        }
        else {
            setFlightNum(value);
            //fncTransitionEffect(value, id, fieldId);
        }
    }

    const fncCheckValidations = () => {
        if (flightDate == '') {
            setErrorDate('*Please select Date.');
            return false;
        }
        else if (origin === '' || origin.toUpperCase() === "Select a Orign".toUpperCase()) {
            setErrorOrigin("*Please select Origin.");
            return false;
        }
        else if (destination === '') {
            setErrorDestination("*Please select Destination.");
            return false;
        } else if (flightnum === '') {
            setErrorFlightNum("*Please provide flight number.");
            return false;
        }
        return true;
        // else if (carriercode == '') {
        //     setErrorCarrierCode("*Please select Carrier Code.");
        //     return false;
        // }
    }

    const fncSearchButtonClick = () => {
        const isValid = fncCheckValidations();
        if (isValid) {
            fncManifestDetails({
                Date: flightDate,
                DepartureStation: origin,
                ArrivalStation: destination,
                FlightNo: flightnum,
                CarrierCode: process.env.REACT_APP_AirlineCode
            })
            .then((response) => {
                if (response.status == "401" && response.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    notify(response.statusText);
                } else {
                    if (!response.data.isError) {
                            // console.log('response.data', response);
                            dispatch(flightManifestDetails(
                                    {
                                            type: "",
                                            manifestDetails: {
                                                    totalManifestCounts: response.data.totalManifestCounts,
                                                    passengerSummaries: response.data.passengerSummaries
                                            }
                                    }
                            ));
                    } else {
                            notify(response.data.errorDetail.errorMessage);
                            console.log(response.data.errorDetail);
                    }
            }
            })
        }
    }

    return (
        <div>
            {
                manifest === null ? 
                <div class="card mt-3 py-3">
                <div class="manifestSearch">
                    <div class="d-flex justify-content-between">
                        <h4 class="dark-text bold font-xxl mb-3">Manifest Counts Search</h4>
                        <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-end  mb-3">
                            <div class="form-group comment-search sp-formField align-self-center mb-0">
                                <a aria-label="Close" onClick={goBack}onKeyDown={(e)=>{
                            if (e.key === "Enter") {
                                goBack();
                   } } } ><i class="fa fa-times OrangeShadow" tabIndex={0}></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6 mb-4 ">
                            <div class="form-floating date ">
                                <DatePicker
                                autocomplete="new-date"
                                name="date"
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                                selected={flightDate}
                                onSelect={(e) => { handleDateSelect(e) }}
                                onChange={(e) => { handleDateChange(e) }}
                                />
                                {/* <input type="text" class="form-control" id="dateInput" placeholder="DD/MM/YYYY" /> */}
                                <span class="icon">
                                    <img class="icon-24" src="newImages/icon-date.svg"/>
                                </span>
                                <p className="clsErrorDate" >{dateError}</p>
                                {/* <label for="dateInput">Flight Date</label> */}
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-4 ">
                            <div class="departure">
                                <div class="icon">
                                    <img src="newImages/departure.svg" alt="departure" />
                                </div>
                                <div class="form-floating">
                                    <select class="form-select focusClass" value={origin} onChange={e => fncOriginChange(e)} id="departure" aria-label="departure">
                                        <option id="0">Select a Origin</option>
                                        {
                                            ReduxOriginDropdown.length === 0 ? '' : ReduxOriginDropdown.map((dest, i) =>
                                                <option id={dest.stationCode}>{dest.stationCode}</option>
                                            )
                                        }
                                    </select>
                                    <label for="origin">Origin</label>
                                </div>
                                <p className="clsError" >{st_ErrorOrigin}</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-4">
                            <div class="arrival">
                                <div class="icon">
                                    <img src="newImages/arrival.svg" alt="arrival" />
                                </div>
                                <div class="form-floating ">
                                    <select class="form-select focusClass" value={destination} onChange={e => fncDestinationChange(e)} id="arrival" aria-label="arrival">
                                        <option id="0">Select a Destination</option>
                                        {
                                            ReduxDestinationDropdown.length === 0 ? '' : ReduxDestinationDropdown.map((dest, i) =>
                                                <option id={dest.stationCode}>{dest.stationCode}</option>
                                            )
                                        }
                                    </select>
                                    <label for="destination">Destination</label>
                                </div>
                                <p className="clsError" >{st_ErrorDestination}</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-4 ">
                            <div class="form-floating  ">
                                <input type="text" class="form-control focusClass" onChange={(e) => { fncOnchange(e) }} value={flightnum} id="flightNo" placeholder="Flight No" />
                                <label for="flightNo">Flight No.</label>
                                <p className="clsError" >{st_ErrorFlightNum}</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-4 ">
                            <div class="form-floating  ">
                                    <select class="form-select focusClass">
                                        <option id={process.env.REACT_APP_AirlineCode}>{process.env.REACT_APP_AirlineCode}</option>
                                    </select>
                                {/* <input type="text" class="form-control" id="carrierCode" placeholder="Carrier Code" /> */}
                                <label for="carrierCode">Carrier Code</label>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-4  d-flex justify-content-end">
                            <div>
                                <button onClick={() => { fncSearchButtonClick() }}  class="btn btn-primary btn-animation SerachBtn">
                                    <span class="px-4">Search</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> :
            <div class="card mt-3 py-3">
                <div class="manifestSearch">
                        <div class="col-12 d-flex justify-content-end  mb-3">
                            <div class="form-group comment-search sp-formField align-self-center mb-0">
                                <a  aria-label="Close" onClick={goBackFromList}
                                 onKeyDown={(e)=>{
                                     if (e.key === "Enter") {
                                goBackFromList();
                            } } }
    ><i class="fa fa-times OrangeShadow" tabIndex={1}></i></a>
                            </div>
                        </div>
                        {
                            !(SearchedFlightDetails && SearchedFlightDetails.recordLocator) ?
                            <div class="manifest-heading mb-4">
                                <div class="sub-header-content-data">
                                    <p class="font-sm mid-dark-text mb-1"><span class="bold me-1 dark-text">Total Manifest Count</span></p>
                                    <p class="font-sm mid-dark-text mb-0">{manifest.totalManifestCounts.totalManifested}</p>
                                </div>
                                <div class="sub-header-content-data">
                                    <p class="font-sm mid-dark-text mb-1"><span class="bold me-1 dark-text">Total Checked-in Count</span></p>
                                    <p class="font-sm mid-dark-text mb-0">{manifest.totalManifestCounts.totalCheckIn}</p>
                                </div>
                                <div class="sub-header-content-data">
                                    <p class="font-sm mid-dark-text mb-1"><span class="bold me-1 dark-text"> Total No Show Count</span></p>
                                    <p class="font-sm mid-dark-text mb-0">{manifest.totalManifestCounts.totalNoShow}</p>
                                </div>
                                <div class="sub-header-content-data">
                                    <p class="font-sm mid-dark-text mb-0"><span class="bold me-1 dark-text">Total Stand By Count</span></p>
                                    <p class="font-sm mid-dark-text mb-0">{manifest.totalManifestCounts.totalStandby}</p>
                                </div>
                                <div class="sub-header-content-data">
                                    <p class="font-sm mid-dark-text mb-0"><span class="bold me-1 dark-text">Total Boarded Count</span></p>
                                    <p class="font-sm mid-dark-text mb-0">{manifest.totalManifestCounts.totalBoarded}</p>
                                </div>
                            </div> : null
                        }
                    <h4 class="dark-text bold font-xxl mb-4">Manifest Counts Categorywise</h4>
                <table class="manifest-table table">
                        <thead>
                            <tr>
                                <th>
                                    Category
                                </th>
                                <th>
                                    Checked-In
                                </th>
                                <th>
                                    Non Checked-In
                                </th>
                                <th>
                                    Boarded
                                </th>
                                <th>
                                    No Show
                                </th>
                            </tr>
                        </thead>
                        <tbody class="mid-dark-text">
                            <tr>
                                <td>Male</td>
                                <td>{passengerSummary.checkedInMale}</td>
                                <td>{passengerSummary.nonCheckedInMale}</td>
                                <td>{passengerSummary.boardedMale}</td>
                                <td>{passengerSummary.noShowMale}</td>
                            </tr>
                            <tr>
                                <td>Female</td>
                                <td>{passengerSummary.checkedInFemale}</td>
                                <td>{passengerSummary.nonCheckedInFemale}</td>
                                <td>{passengerSummary.boardedFemale}</td>
                                <td>{passengerSummary.noShowFemale}</td>
                            </tr>
                            <tr>
                                <td>Child</td>
                                <td>{passengerSummary.checkedInChild}</td>
                                <td>{passengerSummary.nonCheckedInChild}</td>
                                <td>{passengerSummary.boardedChild}</td>
                                <td>{passengerSummary.noShowChild}</td>
                            </tr>
                            <tr>
                                <td>Infant Count</td>
                                <td>{passengerSummary.checkedInInfant}</td>
                                <td>{passengerSummary.nonCheckedInInfant}</td>
                                <td>{passengerSummary.boardedInfant}</td>
                                <td>{passengerSummary.noShowInfant}</td>
                            </tr>
                        </tbody>
                </table>
                </div>
            </div>
            }
        </div>
    );
}

export default ManifestDetail;